module.exports = __webpack_public_path__ + "img/speech_14.4088073b.jpeg";